import { type ReactNode } from "react";

import { type PackagingSelectionVariant } from "~/common/components/PackagingSelection/PackagingSelectionVariant";
import { NewPackagingSelection } from "~/common/components/PackagingSelection/NewPackagingSelection/NewPackagingSelection";
import type { ProductDescriptor } from "~/feature/ProductDescriptor/v1/types";

export interface PackagingSelectionProps {
  className?: string;
  selectedCode: string;
  onSelectCode?: (packCode: string) => void;
  product: ProductDescriptor;
  variant?: PackagingSelectionVariant;
  renderExtraInfoOnItem?: (packCode: string) => ReactNode;
  initiallyExpanded?: boolean;
  disabled?: boolean;
}

export const PackagingSelection = (props: PackagingSelectionProps) => {
  return <NewPackagingSelection {...props} />;
};
